import { useAtomValue } from 'jotai';
import * as THREE from 'three';

import { activeData3dAtom, comparisonData3dAtom, currentFrameAtom, syncedFrameAtom } from '@store';

import { GolfClubModel } from '../Skeleton/ClubTrack';

type ClubProps = {
    origin?: string;
};

const CURRENT = 'current';

export function Club({ origin }: ClubProps) {
    const data = useAtomValue(origin === CURRENT ? activeData3dAtom : comparisonData3dAtom);

    const frame = useAtomValue(origin === CURRENT ? currentFrameAtom : syncedFrameAtom);
    if (!data?.clubTrack) return null;
    const shaftStartFrames = data?.clubTrack['shaft_start_coordinates'];
    const shaftEndFrames = data?.clubTrack['shaft_end_coordinates'];

    const start = shaftStartFrames[frame] ?? shaftStartFrames[shaftStartFrames.length - 1];
    const end = shaftEndFrames[frame] ?? shaftEndFrames[shaftEndFrames.length - 1];

    return (
        <group>
            <GolfClubModel
                gripPoint={new THREE.Vector3(...start)}
                headPoint={new THREE.Vector3(...end)}
                isComparison={false}
            />
        </group>
    );
}
